import React from 'react';
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, Paper, TextField, Typography } from '@mui/material';
import { pickupOtherCount } from './enrollmentPickup';

export default function PickupAuthorization({ form, errors = {}, onFieldChange, onPatch }) {
  const count = pickupOtherCount(form);
  const removePerson = index => {
    const patch = { retiradaOutrosQuantidade: count - 1 };
    for (let n = index; n <= count; n += 1) {
      ['Nome', 'Parentesco', 'Telefone'].forEach(field => {
        patch[`saidaAcompanhada${field}${n}`] = n < count ? form[`saidaAcompanhada${field}${n + 1}`] || '' : '';
      });
    }
    onPatch(patch);
  };
  return <Box id="requerimento-campo-retiradaAutorizados" sx={{ my: 2 }}>
    <Typography fontWeight={700}>Quem pode retirar o aluno?</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Marque uma ou mais pessoas. Os dados do pai e da mãe são os mesmos da filiação e acompanham suas alterações.</Typography>
    <Grid container spacing={2}>
      {[['Pai', 'pai'], ['Mãe', 'mae']].map(([label, role]) => {
        const suffix = role === 'pai' ? 'Pai' : 'Mae';
        const unavailable = Boolean(form[`naoTem${suffix}`]) || !form[`nome${suffix}`]?.trim();
        const selected = Boolean(form[`retirada${suffix}`]) && !form[`naoTem${suffix}`];
        const phone = form[`celular${suffix}`]?.trim() || form[`telefone${suffix}`]?.trim();
        return <Grid item xs={12} sm={6} key={role}>
          <Paper variant="outlined" sx={{ p: 2, height: '100%', boxSizing: 'border-box', borderColor: selected ? 'primary.main' : 'divider', bgcolor: selected ? '#f0f7ff' : 'background.paper' }}>
            <FormControlLabel label={`${label} autorizad${role === 'mae' ? 'a' : 'o'} a retirar`} control={<Checkbox checked={selected} disabled={unavailable && !selected} onChange={e => onFieldChange(`retirada${suffix}`, e.target.checked)} />} />
            <Typography variant="body2" fontWeight={600}>{unavailable ? `${label} sem cadastro disponível` : form[`nome${suffix}`]}</Typography>
            <Typography variant="body2" color="text.secondary">{unavailable ? 'Preencha a filiação acima para selecionar.' : phone || 'Complete o telefone na filiação acima.'}</Typography>
            {selected && (!phone || !form[`nome${suffix}`]?.trim()) && errors[`retirada${suffix}`] && <Typography role="alert" variant="caption" color="error">{errors[`retirada${suffix}`]}</Typography>}
          </Paper>
        </Grid>;
      })}
    </Grid>
    {Array.from({ length: count }, (_, i) => i + 1).map(n => <Paper variant="outlined" key={n} sx={{ p: 2, mt: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography fontWeight={600}>Outra pessoa {n}{n > 2 ? ' (cadastro anterior)' : ''}</Typography>
        <Button size="small" color="error" onClick={() => removePerson(n)} aria-label={`Remover outra pessoa ${n}`}>Remover</Button>
      </Box>
      <Grid container spacing={2}>
        {[['Nome', 'Nome completo', 'Ex.: Maria da Silva'], ['Parentesco', 'Parentesco ou vínculo', 'Ex.: avó, tio, motorista'], ['Telefone', 'Telefone', '(00) 00000-0000']].map(([field, label, placeholder]) => {
          const key = `saidaAcompanhada${field}${n}`;
          return <Grid item xs={12} sm={field === 'Nome' ? 12 : 6} key={field}><TextField
            fullWidth required id={`requerimento-campo-${key}`} label={`${label} (outra pessoa ${n})`} placeholder={placeholder}
            value={form[key] || ''} onChange={e => onFieldChange(key, e.target.value)}
            error={Boolean(errors[key])} helperText={errors[key] || ''}
            inputProps={field === 'Telefone' ? { inputMode: 'tel' } : {}}
          /></Grid>;
        })}
      </Grid>
    </Paper>)}
    <Button variant="outlined" sx={{ mt: 2 }} disabled={count >= 2} onClick={() => onPatch({ retiradaOutrosQuantidade: count + 1 })}>
      {count === 0 ? 'Adicionar outra pessoa' : 'Adicionar segunda pessoa'}
    </Button>
    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>Até duas outras pessoas, além do pai e da mãe selecionados.</Typography>
    {errors.retiradaAutorizados && <Alert severity="error" sx={{ mt: 1 }}>{errors.retiradaAutorizados}</Alert>}
  </Box>;
}
